import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getFromDate, getToDate, changeRange } from "../../store/order";
import moment from "moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import "./RangePicker.scss";
import "moment/locale/sk";

const RangePicker = ({ from, to, changeRange }) => {
  const modifiers = { start: from, end: to };
  return (
    <div className="row InputFromTo">
      <div className="col-12 col-md-6">
        <DayPickerInput
          className="form-control"
          value={from}
          placeholder="From"
          format="LL"
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            selectedDays: [from, { from, to }],
            disabledDays: { after: to },
            toMonth: to,
            modifiers,
            numberOfMonths: 2,
            locale: "sk"
          }}
          onDayChange={e => changeRange(e, "rangeFrom")}
        />
      </div>
      <div className="col-12 col-md-6">
        <DayPickerInput
          ref={el => (this.to = el)}
          value={to}
          placeholder="To"
          format="LL"
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            selectedDays: [from, { from, to }],
            disabledDays: { before: from },
            fromMonth: from,
            modifiers,
            month: from,
            numberOfMonths: 2,
            locale: "sk"
          }}
          onDayChange={e => changeRange(e, "rangeTo")}
        />
      </div>
    </div>
  );
};
RangePicker.propTypes = {};

const mapStateToProps = state => ({
  from: getFromDate(state.order.rangeFrom),
  to: getFromDate(state.order.rangeTo)
});

const mapDispatchToProps = dispatch => ({
  changeRange: (val, type) => {
    dispatch(changeRange(val, type));
    if (type === "rangeFrom") {
      setTimeout(() => this.to.getInput().focus(), 0);
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RangePicker);



// WEBPACK FOOTER //
// ./src/molecules/containers/RangePicker.js